import React from 'react';

import './Button.scss';

interface ButtonProps {
  label?: string;
  color?: 'one' | 'two' | 'three' | 'four' | 'five' | 'six' | 'white' | 'black' | 'red';
  onClick?: any;
  size?: 'small' | 'medium' | 'large';
  icon?: string;
  className?: string;
  disabled?: boolean;
}

export function Button(props: ButtonProps) {
  return (
    <div
      onClick={!props.disabled ? props.onClick : () => false}
      className={`button color-${props.color || 'none'} size-${props.size || 'medium'} ${
        props.disabled ? 'disabled' : ''
      } ${props.className ? props.className : ''}`}
    >
      {props.label || <img src={`/icons/${props.icon}.svg`} />}
    </div>
  );
}
